import { dedent } from 'ts-dedent';
import { Provider, WorkflowComponentParamType, WorkflowComponentParameterMode } from '../types';
import { removeColumns } from '../utils/schemas';
import { SingleOutputWorkflowComponent } from './common/singleoutputcomponent';
class DropColumn extends SingleOutputWorkflowComponent {
    constructor() {
        super({
            name: 'native.dropcolumn',
            group: 'Data Preparation',
            title: 'Drop Columns',
            description: `
      This component generates a new table with the same content as the input one, except for the selected columns.
      `,
            starred: true
        }, [
            {
                name: 'source',
                type: WorkflowComponentParamType.InputTable,
                title: 'Source table'
            },
            {
                name: 'column',
                type: WorkflowComponentParamType.Column,
                title: 'Columns to drop',
                parent: 'source',
                mode: WorkflowComponentParameterMode.Multiple,
                noDefault: true
            }
        ]);
    }
    async getCode({ workflow, params, connection, codeType, schemas }) {
        const outputTablename = connection.getOutputTableName(workflow.id, this.metadata.name, params, 'result', codeType);
        const preparedParams = this._prepareParameters(params);
        let query = '';
        const columns = Array.isArray(preparedParams.column)
            ? preparedParams.column
            : [preparedParams.column];
        switch (connection.type) {
            case Provider.BigQuery: {
                const select = `SELECT * EXCEPT (${columns.join(', ')})
                      FROM ${connection.quoteName(preparedParams.source)}`;
                query = connection.getCreateTempTableQuery(outputTablename, select, codeType, null);
                break;
            }
            case Provider.DatabricksRest: {
                const select = `SELECT /*+ REPARTITION(40) */ * EXCEPT (${columns.join(', ')})
                      FROM ${connection.quoteName(preparedParams.source)}`;
                query = connection.getCreateTempTableQuery(outputTablename, select, codeType, null);
                break;
            }
            case Provider.Snowflake: {
                const select = `SELECT * EXCLUDE (${columns.join(', ')})
                      FROM ${connection.quoteName(preparedParams.source)}`;
                query = connection.getCreateTempTableQuery(outputTablename, select, codeType, null);
                break;
            }
            default:
                const select = `SELECT *
                      FROM ${connection.quoteName(preparedParams.source)}`;
                query = connection.getCreateTempTableQuery(outputTablename, select, codeType, null);
                for (const column of columns) {
                    query += dedent `
          ALTER TABLE ${outputTablename}
          DROP COLUMN ${column};`;
                }
        }
        return {
            query,
            outputs: { result: outputTablename }
        };
    }
    canProvideOutputSchemas() {
        return true;
    }
    getOutputSchema({ columns, params }) {
        const preparedParams = this._prepareParameters(params);
        const columnsToRemove = Array.isArray(preparedParams.column)
            ? preparedParams.column
            : [preparedParams.column];
        return removeColumns(columns.source, columnsToRemove);
    }
}
export { DropColumn };
